<sw-nav-link>
    <sw-icon icon="chevron-down"></sw-icon>
</sw-nav-link>